import {stringNorm} from './stringNorm'


export function testTerm({term, user}) {

  if (!term) return false

  if (stringNorm(user.first_name).indexOf(term) !== -1) return true
  if (stringNorm(user.last_name).indexOf(term) !== -1) return true
  if (stringNorm(user.email).indexOf(term) !== -1) return true

  return false
}




export function testDeploymentRole({deploymentRole, user}) {

  if (!deploymentRole || !deploymentRole.length) return false

  for (let deploymentId of Object.keys(user.deployment_roles || {})) {
    if (deploymentRole.indexOf(user.deployment_roles[deploymentId]) !== -1) return true
  }

  return false
}




export function testAccountStatus({accountStatus, user}) {

  if (!accountStatus || !accountStatus.length) return false

  if (accountStatus.indexOf(user.vera_account_status) !== -1) return true

  return false
}




export function testPasswordStatus({passwordStatus, user}) {

  if (!passwordStatus || !passwordStatus.length) return false

  if (passwordStatus.indexOf(user.vera_password_status) !== -1) return true

  return false
}
